import React from "react";
import Image from "../Image/Image";
import { PropTypes } from "prop-types";
import SubSectionText from "components/SubSectionText/SubSectionText";
import { InnerSubSection, SubSectionContainer } from "./SubSection.styled";

const SubSection = (props) => {
  const { height, marginTop, reverse } = props;
  return (
    <SubSectionContainer marginTop={marginTop} container $reverse={reverse}>
      <InnerSubSection height={height}>
        {reverse ? (
          <Image
            image={props.image}
            alt=""
            width={props.width}
            height={height}
          />
        ) : (
          <SubSectionText
            text={props.text}
            textColor={props?.textColor}
            HighlightColor={props?.HighlightColor}
            applyPadding={props.applyPadding}
            IsBold={props.IsBold}
          />
        )}
      </InnerSubSection>
      <InnerSubSection item $reverse={reverse} height={height}>
        {reverse ? (
          <SubSectionText
            text={props.text}
            textColor={props?.textColor}
            HighlightColor={props?.HighlightColor}
            applyPadding={props.applyPadding}
            IsBold={props.IsBold}
          />
        ) : (
          <Image
            image={props.image}
            alt=""
            width={props.width}
            height={height}
          />
        )}
      </InnerSubSection>
    </SubSectionContainer>
  );
};
SubSection.propTypes = {
  text: PropTypes.any,
  image: PropTypes.any,
  reverse: PropTypes.bool,
  textColor: PropTypes.string,
  HighlightColor: PropTypes.string,
  applyPadding: PropTypes.bool,
  IsBold: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string,
  marginTop: PropTypes.string,
};
SubSection.defaultProps = {
  reverse: false,
  textColor: "white",
  HighlightColor: "thertiary",
  height: "100%",
  width: "auto",
};
export default SubSection;
